import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Heart Icon Filled',
};

export const HeartCviFilledIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                d="M10.0062 4.83751C10.9879 3.19604 12.8498 2.26597 14.7735 2.49209C17.1243 2.76842 18.9398 4.68859 19.084 7.05116L19.1038 7.37627C19.2311 9.46056 18.4512 11.4981 16.9649 12.9649C16.0534 13.8644 15.0554 14.672 13.9855 15.3759L10.3925 17.7397C10.1533 17.8971 9.84328 17.8964 9.60477 17.738L5.98643 15.3353C4.9671 14.6584 4.01287 13.8883 3.13603 13.0349C1.5865 11.5267 0.783 9.41058 0.940975 7.25402L0.960974 6.98101C1.1316 4.65179 2.93049 2.77096 5.24981 2.49684C7.1709 2.26978 9.02876 3.19981 10.0062 4.83751Z"
            />
        </SvgIcon>
    );
};
